export default "__VITE_ASSET__01T5BBJV__"